import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import Image from '../assets/Alerta Normativa-logo2026-claro.png';

const Home = () => {
  return (
    <Box sx={{ padding: { xs: 2, sm: 3 }, maxWidth: 600, margin: 'auto' }}>
      <Paper elevation={3} sx={{ padding: { xs: 2, sm: 3 } }} >
        <Box sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            Bienvenido/a a Alerta Normativa
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={Image}
            alt="Imagen de bienvenida"
            style={{ margin: '30px 0', height: 'auto', maxWidth: '100%', objectFit: 'contain' }}
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
          <Typography variant="body1">
            Utilice el menú de la izquierda para navegar por las diferentes secciones de la aplicación.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Home;
